import Immutable from 'immutable';

export const START_SPINNER = 'takeback/frontend/START_SPINNER';
export const STOP_SPINNER = 'takeback/frontend/STOP_SPINNER';

const initialState = Immutable.Map();

/* Reducers */
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case START_SPINNER:
        return state.update(map => {
            const { id } = action;
            return map.has(id)
                ? map.set(id, map.get(id) + 1)
                : map.set(id, 1);
        });
    case STOP_SPINNER:
        return state.update(map => {
            const { id } = action;
            return map.has(id) && map.get(id) >= 2
                ? map.set(id, map.get(id) - 1)
                : map.delete(id);
        });
    default: return state;
    }
}

/* Selectors */
export function isSpinning(state, id) {
    return (state.spinner || state).has(id);
}

/* Actions */
export function startSpinner(id) {
    return {
        type: START_SPINNER,
        id,
    };
}

export function stopSpinner(id) {
    return {
        type: STOP_SPINNER,
        id,
    };
}
